module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "id": "abb"
    }
  }), _c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "75%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("AMNH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("American Museum of Natural History, New York, New York")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("ANSP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Academy of Natural Sciences of Philadelphia, Philadelphia, Pennsylvania")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("CMC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Cincinnati Museum Center, Cincinnati, Ohio")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("CMNH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Carnegie Museum of Natural History, Pittsburgh, Pennsylvania")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("DMNH/DMNS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Denver Museum of Nature and Science, Denver, Colorado")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("ESU")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Emporia State University Geology Museum, Emporia, Kansas")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("FFHM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Fick Fossil and History Museum, Oakley, Kansas")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("FHSM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Sternberg Museum of Natural History, Fort Hays State University, Hays, Kansas")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("FMNH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("The Field Museum of Natural History, Chicago, Illinois")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("KU")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("University of Kansas Invertebrate Paleontology Collection, Lawrence, Kansas")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("KUVP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("University of Kansas Vertebrate Paleontology Collection, Lawrence, Kansas")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("LACMNH")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Los Angeles County Museum of Natural History, Los Angeles, California")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("MCZ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Museum of Comparative Zoology, Harvard, Cambridge, Massachusetts")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("NAMAL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("North American Museum of Ancient Life, Lehi, Utah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("NJSM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("New Jersey State Museum, Trenton, New Jersey")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("RMDRC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Rocky Mountain Dinosaur Resource Center, Woodland Park, Colorado")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("ROM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Royal Ontario Museum, Toronto, Ontario, Canada")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("SDSMT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("South Dakota School of Mines and Technology, Rapid City, South Dakota")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("UCM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("University of Colorado Museum, Boulder, Colorado")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("UNO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("University of New Orleans, New Orleans, Louisiana")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("UPI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Uppsala Paleontological Institute, Uppsala University, Sweden")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("UNSM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("University of Nebraska State Museum, Lincoln, Nebraska")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("USNM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("United States National Museum, Washington, D.C.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tablex"
  }, [_c('strong', [_vm._v("YPM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabley"
  }, [_vm._v("Yale Peabody Museum, New Haven, Connecticut")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283c293a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 87
// module chunks = 0